export default __webpack_public_path__ + "static/media/DP2 2A-2EC V04.4d3f5b84.jpg";